// Maaş / Prim Ödemesi Yap (hakediş ödeme) penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'personnel.salaryPayment';

export const personnelSalaryPaymentGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Maaş / prim ödemesi nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Daha önce oluşturduğunuz maaş ve prim hakedişlerini listeler, ödenmemiş olanları kasadan veya bankadan ödersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Maaş / Prim Ödemesi Yap'),
    tabs: t(`${G}.regions.tabs`, 'Maaş Ödemeleri / Prim Ödemeleri'),
    body: t(`${G}.regions.body`, 'Hakediş tablosu'),
    footer: t(`${G}.regions.footer`, 'Kapat'),
  },
  navItems: [
    t(`${G}.nav.salary`, 'Maaş Ödemeleri'),
    t(`${G}.nav.bonus`, 'Prim Ödemeleri'),
  ],
  steps: [
    {
      region: 'tabs',
      title: t(`${G}.s1.title`, '1. Maaş veya prim sekmesini seçin'),
      text: t(`${G}.s1.text`, '"Maaş Ödemeleri" maaş hakedişlerini, "Prim Ödemeleri" prim hakedişlerini gösterir. Liste boşsa önce ⋮ menüsünden "Maaş Oluştur" / "Prim Oluştur" ile hakediş oluşturun.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Ödenmemiş hakedişi bulun'),
      text: t(`${G}.s2.text`, 'Tabloda Tarih, Açıklama, Tutar ve Durumu sütunları vardır. "Ödenmedi" (turuncu) hakediş hiç ödenmemiştir; "Kısmi" (mavi) hakedişin bir kısmı ödenmiştir ve kalan tutar yazar; "Ödendi" (yeşil) tamamen ödenmiştir ve tekrar ödenemez. Sayfa başına 5, 10 veya 25 satır görebilirsiniz.'),
      tips: [
        t(`${G}.s2.tip1`, 'Avans mahsubu kayıtları hakediş değildir, bu listede görünmez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Ödeme kaynağını seçin'),
      text: t(`${G}.s3.text`, 'Satırdaki "Ödeme Yap" düğmesi "Personele Ödeme Yap" penceresini kalan tutar ve "… için maaş/prim ödemesi" açıklamasıyla açar. Ödeme Yöntemi olarak "Nakit" seçip kasayı veya "Banka" seçip banka hesabını belirleyin.'),
      tips: [
        t(`${G}.s3.tip1`, 'Yalnız hakedişin para birimindeki kasa ve banka hesapları (ör. USD hakediş için USD hesaplar), bakiyeleriyle listelenir. Şube yöneticisi yalnız kendi şubesinin hesaplarını görür.'),
        t(`${G}.s3.tip2`, 'Tutar seçilen kasanın/hesabın bakiyesini aşarsa "Yetersiz Bakiye" uyarısı çıkar ve ödeme kaydedilmez.'),
        t(`${G}.s3.tip3`, 'Hakediş ödemesinde "Tahakkuk" seçeneği yoktur; ödeme her zaman kasadan veya bankadan yapılır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Ödemeyi kaydedin ve etkisi'),
      text: t(`${G}.s4.text`, '"Ödemeyi Kaydet"e basınca tutar seçilen kasadan/banka hesabından gider olarak düşülür, personel defterine hakedişe bağlı bir "Ödeme" yazılır ve Güncel Bakiye tutar kadar artar. Ödemelerin toplamı hakediş tutarına ulaşınca hakediş "Ödendi" olur.'),
      tips: [
        t(`${G}.s4.tip1`, 'Kısmi ödeme yapabilirsiniz: daha az öderseniz hakediş "Kısmi" olarak açık kalır, kalanı sonra ödersiniz. Kalan tutardan fazlası ödenemez.'),
        t(`${G}.s4.tip2`, '"Geçmiş tarihli işlem yap" işaretlenirse ödeme ve kasa/banka hareketi seçilen tarihe yazılır.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Pencereyi kapatın'),
      text: t(`${G}.s5.text`, '"Kapat" pencereyi kapatır. Yapılan ödemeler Personel Hareketleri tablosunda hemen görünür. Yanlış ödemeyi oradaki çöp kutusuyla silebilirsiniz: bağlı kasa/banka hareketi geri alınır ve hakediş yeniden açılır (kalan tutar artar). Ödemesi olan bir hakediş, ödemeleri silinmeden silinemez.'),
    },
  ],
});
